import React, { FC, useMemo, memo } from 'react';
import _map from 'lodash/map';
import _pick from 'lodash/pick';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { appConfig, modifiedTileSchemaValueEnum as TILE_SCHEME_VALUE } from '@minecraft.app-config';
import { useTileSchemeText } from '@blocs.common';
import { gqlSubTileSchemaValueEnum } from '@minecraft.graphql-types';
import { FilterData } from '../../../shared/types';

const TILE_SCHEME = _pick(TILE_SCHEME_VALUE, appConfig.enumTagKeysToShow);
const SUB_TILE_SCHEME = gqlSubTileSchemaValueEnum;

type Props = FilterData;

export interface SelectionTagProps extends Props {
  tagType: 'number' | 'letter';
}

const SelectionTag: FC<SelectionTagProps> = ({ name, label, tagType = 'number' }) => {
  const intlTileScheme = useTileSchemeText(true);

  const tagOptions = useMemo(() => {
    const tags = tagType === 'number' ? Object.keys(TILE_SCHEME) : Object.keys(SUB_TILE_SCHEME);

    return _map(tags, (tag) => ({
      value: tagType === 'number' ? TILE_SCHEME[tag] : SUB_TILE_SCHEME[tag],
      label: tagType === 'number' ? intlTileScheme[tag] : SUB_TILE_SCHEME[tag],
    }));
  }, [tagType, intlTileScheme]);

  return (
    <DropdownWithChildren
      withFormik
      withSelectAll
      isMultipleSelect
      name={name}
      toggleLabel={label}
      options={tagOptions}
    />
  );
};

export default memo(SelectionTag);
